import { render, staticRenderFns } from "./default.vue?vue&type=template&id=266aaaa2&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=266aaaa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266aaaa2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/app/components/navigation/Navbar.vue').default,HeaderGroup: require('/app/components/header/HeaderGroup.vue').default,Footer: require('/app/components/Footer.vue').default})
